import React from 'react';
import styled from 'styled-components';
import PText from './PText';

const AboutItemStyles = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 3rem;
  gap: 3rem;

  .title {
    font-size: 2.8rem;
    min-width: 250px;
    flex-shrink: 0;
    color: var(--white);
    font-weight: 600;
  }

  .items {
    display: flex;
    flex-wrap: wrap;
    gap: 1.2rem;
    flex: 1;
  }

  .item {
    background-color: var(--deep-dark);
    padding: 1rem 1.5rem;
    border-radius: 10px;
    white-space: nowrap;
    transition: all 0.3s ease;
    border: 1px solid var(--gray-1);

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
      border-color: var(--white);
    }

    .para {
      max-width: 100%;
      font-size: 1.6rem;
      color: var(--white);
      font-weight: 500;
    }
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;

    .title {
      font-size: 2.4rem;
      min-width: auto;
    }

    .items {
      gap: 1rem;
    }

    .item {
      padding: 0.8rem 1.2rem;

      .para {
        font-size: 1.4rem;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    .items {
      gap: 0.8rem;
    }

    .item {
      padding: 0.7rem 1rem;

      .para {
        font-size: 1.3rem;
      }
    }
  }
`;

export default function AboutInfoItem({
  title = 'Title',
  items = ['HTML', 'CSS'],
}) {
  return (
    <AboutItemStyles>
      <h1 className="title">{title}</h1>
      <div className="items">
        {items.map((item, index) => (
          <div className="item" key={index}>
            <PText>{item}</PText>
          </div>
        ))}
      </div>
    </AboutItemStyles>
  );
}
